<h3 class="title configurator-title">{{ 'workbench.splashback.title' | translate }}</h3>

  <div class="radio-inputs">
    <input
      type="radio"
      id="planTravail"
      name="typeProjet"
      value="PLAN_TRAVAIL"
      [(ngModel)]="typeProjet"
      (change)="onTypeProjetChange($event)"
      [disabled]="disableRadioButtonWorkbench">
    <label for="credencePlanTravail">Plan de travail seul</label>
    <input
      type="radio"
      id="credencePlanTravail"
      name="typeProjet"
      value="CREDENCE_PLAN_TRAVAIL"
      [(ngModel)]="typeProjet"
      (change)="onTypeProjetChange($event)"
      [disabled]="disableRadioButtonCredence">
    <label for="credencePlanTravail">Plan de travail avec crédence</label>
    <input
      type="radio"
      id="credenceSeule"
      name="typeProjet"
      value="CREDENCE_SEULE"
      [(ngModel)]="typeProjet"
      (change)="onTypeProjetChange($event)"
      [disabled]="disableRadioButtonCredence">
    <label for="credenceSeule">Crédence seule</label>
  </div><br/>

<!-- Sélection des côtés de crédences -->
<h4 class="title configurator-subtitle collapse-button">
  {{ 'workbench.splashback.selection' | translate }}
</h4>

<div class="collapse-block">
  <div class="container-fluid">
    <article class="caption">
      <div class="caption-color-line splashback-not-select"></div>
      <p>{{ 'workbench.splashback.captions.not-select' | translate }}</p>
    </article>
    <article class="caption">
      <div class="caption-color-line splashback-select"></div>
      <p>{{ 'workbench.splashback.captions.select' | translate }}</p>
    </article>
  </div>
</div>

<!-- Hauteur de crédence -->
<div class="form-row" *ngIf="hasSplashbacks()">
  <div class="form-label">
    <label>{{ 'workbench.splashback.height' | translate }}</label>
  </div>
  <div class="form-input">
    <div class="mm">
      <input
        [ngClass]="{ invalid: !isHeightValid() }"
        [disabled]="!hasSplashbacks()"
        type="number"
        spellcheck="false"
        step="1"
        [value]="getSplashbackHeight()"
        (change)="changeSplashbackHeight($event)" />
    </div>
  </div>
</div>

<div *ngIf="splashbackCanHaveSideCuts() && hasSplashbacks() && isHeightValid()">
  <h4 class="title configurator-subtitle">{{ 'workbench.splashback.side-cut' | translate }}</h4>
  <div class="d-flex">
    <span class="mr-2">{{ 'workbench.splashback.no' | translate }}</span>
    <div class="custom-control custom-switch">
      <input
        type="checkbox"
        [(ngModel)]="hasSideCut"
        (change)="updateSplashbackSideCuts()"
        class="custom-control-input"
        id="hasSideCutCustomSwitch" />
      <label class="custom-control-label" for="hasSideCutCustomSwitch">{{
        'workbench.splashback.yes' | translate
      }}</label>
    </div>
  </div>
</div>

<!-- Ouvertures de crédence -->
<div class="config-container shadow my-3" *ngIf="hasSplashbacks() && isHeightValid()">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse()">
    {{ 'workbench.splashback.cutting.title' | translate }}
  </h4>

  <div class="collapse-block" *ngIf="isVisible">
    <div class="container-fluid">
      <ng-workbench-splashback-cutting-infos [cuttings]="cuttings"></ng-workbench-splashback-cutting-infos>
    </div>
  </div>
</div>


